export default __webpack_public_path__ + "img/43fdfd63bf200aed615ff72f72541c49.png";